import type { ContentObjectList, ContentObjectView, NonEventContentObjectDetail } from 'models';
import type { ReactNode } from 'react';
import { canLikeContentObject, usePermissions } from 'permissions';
import { LikeButton } from 'features/like';
import { CommentButton } from '../comment-button';
import { RepostButton } from '../repost-button';
import { ShareButton } from '../share-button';
import { ViewButton } from '../view-button';

type P = {
  item: ContentObjectList | NonEventContentObjectDetail;
  onShowComments?: () => void;
  preview: ReactNode;
  view: ContentObjectView;
};

const BasicActionBar = ({ item, onShowComments, preview, view }: P) => {
  const { canCommentContentObjectList, canRepostContentObjectList } = usePermissions();

  return (
    <div className="basic-action-bar">
      {view === 'bookmark' ? <ViewButton item={item} /> : null}

      {view === 'other' || view === 'feed' ? (
        <>
          {canLikeContentObject({ contentObject: item }) ? <LikeButton contentObject={item} type="action" /> : null}
          {canCommentContentObjectList({ contentObject: item }) ? (
            <CommentButton onShowComments={onShowComments} />
          ) : null}
          {canRepostContentObjectList({ contentObject: item }) ? <RepostButton item={item} preview={preview} /> : null}
          <ShareButton item={item} />
        </>
      ) : null}
    </div>
  );
};

export default BasicActionBar;
